// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'סגור',
  error: () => 'שגיאה',
  warn: () => 'אזהרה',
  info: () => 'מידע',
  confirmation: () => 'אישור',
  progressIndeterminate: () => 'בתהליך',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'בין ' + p['FROM_SECTION'] + ' ו-' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. לא נמצא פרק תואם.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'לחץ על Enter כדי לבחור ערך.',
  indexer_touchInstructionText: () =>
    'הקש פעמיים והחזק כדי להיכנס למצב מחוות, ולאחר מכן גרור מעלה ומטה כדי להתאים את הערך.',
  inputPassword_show: () => 'הצג סיסמה',
  inputPassword_hide: () => 'הסתר סיסמה',
  inputPassword_hidden: () => 'סיסמה נסתרת',
  formControl_clear: () => 'מחק',
  formControl_loading: () => 'טוען',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'חריגה מהאורך המרבי ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' תווים נותרו.',
  formControl_requiredMessageDetail: () => 'הזן ערך.',
  select_requiredMessageDetail: () => 'בחר ערך',
  select_noMatchesFound: () => 'לא נמצאו התאמות.',
  select_oneMatchFound: () => 'נמצאה התאמה אחת',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' התאמות נמצאו',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' או יותר התאמות נמצאו',
  selectMultiple_selectedValues: () => 'ערכים נבחרים',
  selectMultiple_showSelectedValues: () => 'הצג ערכים בלבד.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' ערכים נבחרו.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'הקש על Backspace או Delete כדי להסיר את הערך שנבחר.',
  selectMultiple_apply: () => 'החל',
  selectMultiple_back: () => 'חזרה',
  selector_selected: () => 'תיבת תיוג מסומנת',
  selector_unselected: () => 'תיבת תיוג לא מסומנת',
  userAssistance_learnMore: () => 'פרטים נוספים',
  userAssistance_required: () => 'דרוש',
  filePicker_singleFileUploadError: () => 'טען קובץ אחד בכל פעם',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'אי אפשר להעלות קבצים מסוג ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'אי אפשר להעלות קבצים מסוג: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'לא ידוע',
  filePicker_dropzonePrimaryText: () => 'גרור ושחרר',
  filePicker_dropzoneSecondaryText: () => 'בחר קובץ או שחרר אותו כאן',
  filePicker_dropzoneSecondaryTextMultiple: () => 'בחר קבצים או שחרר אותם כאן',
  filePicker_addFiles: () => 'הוסף קבצים',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'הגדל',
  inputNumber_decrease: () => 'הקטן',
  inputNumber_converterParseError: () => 'הזן מספר.',
  noData_message: () => 'אין פריטים להצגה',
  message_navigationFromMessagesRegion: () =>
    'מזין אזור הודעות. לחץ על F6 כדי לנווט חזרה לרכיב שהיה קודם במוקד.',
  message_navigationToMessagesRegion: () =>
    'אזור ההודעות מכיל הודעות חדשות. לחץ על F6 כדי לנווט לאזור ההודעות האחרון.',
  messageToast_allMessagesClosed: () => 'כל ההודעות המוקפצות סגורות.',
  expandableList_groupCollapse: () => 'מכווץ',
  expandableList_groupExpand: () => 'מורחב',
  expandableList_expandCollapseInstructionText: () => 'יש להשתמש במקשי החצים כדי להרחיב ולצמצם',
  list_suggestion: () => 'הצעה',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'שלב ' + p['currentStep'] + ' מתוך ' + p['numberOfSteps'],
  train_current: () => 'שוטף',
  train_visited: () => 'נרשמו ביקורים',
  train_not_visited: () => 'לא נרשמו ביקורים',
  train_message_type: () => 'סוג הודעה',
  viz_drillable: () => 'ניתן לגלילה',
  dataVisualization_stateSelected: () => 'נבחר',
  dataVisualization_stateUnselected: () => 'לא נבחר',
  dataVisualization_noData: () => 'אין נתונים להצגה'
};
export default bundle;
